// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__JYb_N","options":"AnswerScale_options__3Uf1r","selected":"AnswerScale_selected__2yExt"};